"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

/**
 * @class
 * @classdesc Armundia Utils
 * This Object is treated as a class so the usage would be 'new common.Utils()'
 * @constructor
 */
function Utils() {
  this.lut = null;
}
/**
 * 
 * @param {*} pre 
 */


Utils.prototype.uuid = function (pre) {
  return (0, _lodash.uniqueId)(pre);
};
/**
 * 
 */


Utils.prototype._assureLut = function () {
  if (this.lut) return;
  this.lut = [];

  for (var i = 0; i < 256; i++) {
    this.lut[i] = (i < 16 ? '0' : '') + i.toString(16);
  }
};
/**
 * 
 */


Utils.prototype.guid = function () {
  this._assureLut();

  var d0 = Math.random() * 0xffffffff | 0;
  var d1 = Math.random() * 0xffffffff | 0;
  var d2 = Math.random() * 0xffffffff | 0;
  var d3 = Math.random() * 0xffffffff | 0;
  var lut = this.lut;
  return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '_' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '_' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '_' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '_' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
};
/**
 * 
 * @param {*} val 
 */


Utils.prototype.isNil = function (val) {
  return val === undefined || val === null || val.toString() === "" || val.toString().trim() === "";
};
/**
 * 
 */


Utils.prototype.strjoin = function () {
  if (arguments.length < 2) return "";
  var separator = arguments[0];
  var res = "";
  var sep = "";

  for (var i = 1; i < arguments.length; i++) {
    var r = arguments[i];
    if (!r) continue;
    res += sep + r;
    sep = separator;
  }

  return res;
};
/**
 * 
 * @param {*} base 
 * @param {*} separator 
 * @param {*} others 
 */


Utils.prototype.union = function (base, separator, others) {
  var all = {};

  if (!separator) {
    separator = " ";
  }

  if (base) {
    var bb = base.split(separator);
    if (bb === null || bb.length < 2) all[base] = base;else {
      for (var i = 0; i < bb.length; i++) {
        var b = bb[i];
        all[b] = b;
      }
    }
  }

  if (others) {
    var oo = others.split(separator);

    if (oo === null || oo.length < 2) {
      var o = others;

      if (o.startsWith("-")) {
        o = o.substring(1);
        all[o] = null;
      } else {
        all[o] = o;
      }
    } else {
      for (var _i = 0; _i < oo.length; _i++) {
        var _o = oo[_i];

        if (_o.startsWith("-")) {
          _o = _o.substring(1);
          all[_o] = null;
        } else {
          all[_o] = _o;
        }
      }
    }
  }

  var res = "";
  var sep = "";
  var keys = Object.keys(all);

  for (var _i2 = 0; _i2 < keys.length; _i2++) {
    var k = keys[_i2];
    if (!k) continue;
    var _o2 = all[k];
    if (_o2 === null) continue;
    res += sep + k;
    sep = separator;
  }

  return res;
};
/**
 * 
 * @param {*} obj 
 */


Utils.prototype.toArray = function (obj) {
  if (obj === undefined || obj === null) return null;
  var kk = Object.keys(obj);
  var res = [];

  for (var i = 0; i < kk.length; i++) {
    var k = kk[i];
    res.push(obj[k]);
  }

  return res;
};
/**
 * 
 * @param {*} fieldPath 
 * @param {*} item 
 */


Utils.prototype.getVal = function (fieldPath, item) {
  if (item === undefined || item === null || fieldPath === undefined || fieldPath === null) return null; // use path to get value

  var idx = ("" + fieldPath).indexOf('.');
  if (idx === -1) return item[fieldPath];else {
    var pp = fieldPath.split('.');
    var o = item;

    for (var i = 0; i < pp.length; i++) {
      o = o[pp[i]];

      if (o === null || o === undefined) {
        o = null;
        break;
      }
    }

    return o;
  }
};
/**
 * 
 * @param {*} text 
 */


Utils.prototype.toId = function (text) {
  if (!text) return null; // da https://gist.github.com/mathewbyrne/1280286

  return text.toString().toLowerCase().replace(/[^\w]+/g, ' ') // Remove all non-word chars
  .trim().replace(/\s+/g, '_') // Replace spaces with _
  .replace(/\_\_+/g, '_'); // Replace multiple _ with single _
};
/**
 * Aggiunge al dominio passato in ingresso (oggetto di tipo ApDom pervenuto
 * da Java) l'attributo valCampo (gi� presente sotto id.valCampo) in modo da
 * renderlo compatibile con le CoolSelect.
 * 
 * TODO Per il momento questa funzione fa side effects sull'oggetto originale
 *      passato in ingresso. In futuro sarebbe comodo gestire la modifica
 *      con meccanismi di immutabilit�.
 * 
 * @param {*} apDom 
 */


Utils.prototype.updateDomForSelect = function (apDom) {
  if (apDom) {
    apDom.forEach(function (item) {
      item.valCampo = item.id.valCampo;
    });
  }

  return apDom;
};
/**
 * 
 * @param {*} fieldPath 
 * @param {*} item 
 * @param {*} value 
 */


Utils.prototype.setVal = function (fieldPath, item, value) {
  if (item === undefined || item === null || fieldPath === undefined || fieldPath === null) return null; // use path to set value

  var idx = ("" + fieldPath).indexOf('.');
  if (idx === -1) item[fieldPath] = value;else {
    var pp = fieldPath.split('.');
    var o = item;

    for (var i = 0; i < pp.length - 1; i++) {
      o = o[pp[i]];

      if (o === null || o === undefined) {
        o = {};
        break;
      }
    }

    o[pp[pp.length - 1]] = value;
  }
};

var _default = new Utils();

exports.default = _default;